module.exports = __webpack_public_path__ + "media/newstyle/images/logo-apple-fb6deaefe1295f1215bff448ca08ef2d.png";